export const appListingMetrics = {
  basic: {
    metrics: ["Gas used", "Transaction count (contracts)", "Active addresses"],
    total: 15,
  },
  standardized: {
    metrics: ["Total value locked", "Fees", "Active users"],
    total: 28,
  },
}
